import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedNotification = _resolveComponent("SharedNotification")!
  const _component_SharedModal = _resolveComponent("SharedModal")!
  const _component_SharedDeposit = _resolveComponent("SharedDeposit")!
  const _component_DefaultLayout = _resolveComponent("DefaultLayout")!
  const _component_AuthLayout = _resolveComponent("AuthLayout")!
  const _component_AdminLayout = _resolveComponent("AdminLayout")!
  const _component_LandingLayout = _resolveComponent("LandingLayout")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createVNode(_Transition, { name: "opacity" }, {
      default: _withCtx(() => [
        (_ctx.isNotificationShow)
          ? (_openBlock(), _createBlock(_component_SharedNotification, {
              key: 0,
              class: _normalizeClass(_ctx.b('notification'))
            }, null, 8, ["class"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "opacity" }, {
      default: _withCtx(() => [
        (_ctx.isModalShow)
          ? (_openBlock(), _createBlock(_component_SharedModal, {
              key: 0,
              class: _normalizeClass(_ctx.b('modal'))
            }, null, 8, ["class"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "opacity" }, {
      default: _withCtx(() => [
        (_ctx.isDepositShow)
          ? (_openBlock(), _createBlock(_component_SharedDeposit, {
              key: 0,
              class: _normalizeClass(_ctx.b('modal'))
            }, null, 8, ["class"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!!_ctx.userRepo.userInfo.id && _ctx.displayedLayout === 'default')
      ? (_openBlock(), _createBlock(_component_DefaultLayout, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.displayedLayout === 'auth')
      ? (_openBlock(), _createBlock(_component_AuthLayout, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.displayedLayout === 'admin')
      ? (_openBlock(), _createBlock(_component_AdminLayout, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.displayedLayout === 'landing')
      ? (_openBlock(), _createBlock(_component_LandingLayout, { key: 3 }))
      : _createCommentVNode("", true)
  ], 2))
}